const RoutesPath = {
  // Authentication
  login: "/login",
  forgotPassword: "/forgot-password",
  otpVerify: "/otp-verify",
  resetPassword: "/reset-password",

  // Authentication Coordinator
  cologin: "/login-co",
  coforgotPassword: "/forgot-password-co",
  coordinatorotpVerify: "/verifyOtp",
  coresetPassword: "/reset-password-co",


  // - Dashboard Website
  home: "/",
  termsAndConditions: "/terms-and-conditions",
  cancellationPolicy: "/cancellation-policy",
  privacyPolicy: "/privacy-policy",
  aboutUs: "/about-us",
  services: "/services",
  contactUs: "/contact-us",
  bharatSAT: "/bharat-sat",
  bharatSatScholarship: "/bharat-sat-scholarship",
  joinAsCoordinator: "/join-as-a-coordinator",
  faq: "/frequently-asked-questions",
  studentRegistration: "/student-registration",
  termsAndConditionsCoordinator: "/terms-and-conditions-coordinator",
  blog: "/blog",
  blogdetails: "/blogdetails",
  deleteuser: "/deleteuser",

  // -Dashboard Student
  dashboardstudent: "/dashboard-student",
  studymaterials: "/study-materials",
  studymodules: "/study-modules",
  studytopics: "/study-topics",
  mocktest: "/mocktest",
  mymocktest: "/mymocktest",
  showresult: "/showresult",
  viewresult: "/viewresult",
  orderhistory: "/order-history",
  changepassword: "/change-password",
  packagedetails: "/package-details",
  addtocart: "/cart",
  checkout: "/checkout",
  studentprofile: "/student-profile",
  paidsyllabus: "/paidsyllabus",
  bharatsat: "/bharatsat",


  // -Dashboard Coordinator
  dashboardcoordinator: "/dashboard-coordinator",
  withdrawlrequest: "/withdrawl-request",
  transactionhistory: "/transaction-history",
  updatebankdetails: "/updatebankdetails",
  coordinatorchangepassword: "/co-changepassword",
  profile: "/profile",

 // BharatSatExamAuthentication
 bharatsatexamlogin: "/bharatsatexam/:encodedId",
 bharatsatexamforgotpassword: "/bharatsatexam/forgot-password",
 bharatsatexamresetpassword: "/bharatsatexam/reset-password",
 bharatsatexamotpverify: "/bharatsatexam/otp-verify",


 // BharatSatTest
 bharatSatTest:"/bharatSatTest",



};

export default RoutesPath;
